import { useState } from "react";
import { IconButton, Link, MessageBarType, Stack, Text } from "@fluentui/react";
import MessageBarComponent from "../../../Util/MessageBarComponent";
import env from "../../../../env";

const { REACT_APP_STS_BASE_URL } = env;

function buildMetadataUrl() {
  if (!REACT_APP_STS_BASE_URL) {
    return "";
  }

  const baseUrl = REACT_APP_STS_BASE_URL.endsWith("/")
    ? REACT_APP_STS_BASE_URL
    : `${REACT_APP_STS_BASE_URL}/`;

  return `${baseUrl}SamlMetadata/Export`;
}

const ServiceProviderInfoTab = () => {
  const [copyFeedback, setCopyFeedback] = useState("");
  const [copyFeedbackType, setCopyFeedbackType] = useState(MessageBarType.success);

  const metadataUrl = buildMetadataUrl();

  const handleCopy = async () => {
    try {
      if (!metadataUrl) {
        throw new Error("Metadata URL unavailable");
      }

      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        throw new Error("Clipboard API unavailable");
      }

      await navigator.clipboard.writeText(metadataUrl);

      setCopyFeedback("Metadata URL copied to clipboard.");
      setCopyFeedbackType(MessageBarType.success);
      setTimeout(() => setCopyFeedback(""), 3000);
    } catch (error) {
      setCopyFeedback("Unable to copy URL. Please copy it manually.");
      setCopyFeedbackType(MessageBarType.error);
    }
  };

  return (
    <Stack tokens={{ childrenGap: 8 }}>
      <Text variant="mediumPlus">Metadata Link</Text>
      <Text variant="small">
        This is our metadata, which customers put into their SSO configuration in order to establish trust with our system. Share this metadata URL with customers when configuring SAML integration. Simply providing the link is recommended.
      </Text>

      <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center" style={{ maxWidth: 900 }}>
        <Link
          href={metadataUrl || undefined}
          target="_blank"
          rel="noopener noreferrer"
          title={metadataUrl || "Set REACT_APP_STS_BASE_URL to enable this link"}
          disabled={!metadataUrl}
        >
          iGrad STS SAML Service Provider Metadata
        </Link>
        <IconButton
          iconProps={{ iconName: "Copy" }}
          title="Copy metadata URL"
          ariaLabel="Copy metadata URL"
          onClick={handleCopy}
          disabled={!metadataUrl}
        />
        {copyFeedback && (
          <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
            <MessageBarComponent
              messageType={copyFeedbackType}
              message={copyFeedback}
              showMessage={Boolean(copyFeedback)}
              setShowMessage={() => setCopyFeedback("")}
              isMultiline={false}
            />
          </div>
        )}
      </Stack>
    </Stack>
  );
};

export default ServiceProviderInfoTab;
